import React from 'react';
import { Theme } from '@material-ui/core';
import IntroContainer from '../IntroContainer/IntroContainer';
import Typography from '@material-ui/core/Typography';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Box } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: '20vh',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '15vh',
    },
  },
  paperSuccess: {
    width: '100%',
    maxWidth: 500,
    backgroundColor: '#f4fcfa',
    borderTop: '4px solid #00a968',
    borderRadius: 8,
    textAlign: 'center',
    padding: theme.spacing(5, 4),
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  },
  paperError: {
    width: '100%',
    maxWidth: 500,
    backgroundColor: '#fffcfc',
    borderTop: '4px solid #d32f2f',
    borderRadius: 8,
    textAlign: 'center',
    padding: theme.spacing(5, 4),
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  },
  successText: {
    color: '#00a968',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
  },
  errorText: {
    color: '#d32f2f',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
  },
  subText: {
    color: '#555',
  },
}));

export default function EndPayment() {
  const classes = useStyles();
  const { Code } = useParams<{ Code: string }>();

  const isSuccess = Code === '1';

  let title = '';
  let subMessage = '';

  if (isSuccess) {
    title = '決済が完了しました';
    //subMessage = 'ご利用ありがとうございました。お手続きが正常に完了いたしました。';
  } else {
    title = '決済が完了できませんでした';
    subMessage = '決済から再実行してください。';
  }

  return (
    <IntroContainer>
      <Box className={classes.container}>
        <Paper className={isSuccess ? classes.paperSuccess : classes.paperError}>
          <Typography variant="h5" className={isSuccess ? classes.successText : classes.errorText}>
            {title}
          </Typography>
          <Typography variant="body1" className={classes.subText}>
            {subMessage}
          </Typography>
        </Paper>
      </Box>
    </IntroContainer>
  );
}
